import { render } from "./DeliverySlipList.vue?vue&type=template&id=5627e6bf&ts=true"
import script from "./DeliverySlipList.vue?vue&type=script&lang=ts"
export * from "./DeliverySlipList.vue?vue&type=script&lang=ts"

import "./DeliverySlipList.vue?vue&type=style&index=0&id=5627e6bf&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__